import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_PROGRAMS_LIST, GET_PROGRAMS_LIST_ERROR, GET_PROGRAMS_LIST_SUCCESS } from '../../actions.js';

function* getProgramsList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/programs`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROGRAMS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROGRAMS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROGRAMS_LIST_ERROR, payload: error });
  }
}

export function* watchGetProgramsList() {
  yield takeEvery(GET_PROGRAMS_LIST, getProgramsList);
}

function* getProgramsListSaga() {
  yield all([fork(watchGetProgramsList)]);
}

export default getProgramsListSaga;
